"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var loglevel_1 = __importDefault(require("loglevel"));
var logger = loglevel_1.default.getLogger('app-logger');
// TODO Make configurable via app.config.js, NODE_ENV or similiar.
logger.setLevel('DEBUG');
exports.default = logger;
